import(/* webpackMode: "eager" */ "/codebuild/output/src3800929241/src/src/app/global-error.tsx");
